<template>
  <div class="Wdgt-Auth-Module">
    <p class="Wdgt-Auth-Module__text">Вы уверены, что хотите выполнить выход из своего аккаунта?</p>
    <ButtonMain class="Wdgt-Auth-Module__button" :type="'alert'" :width="'100%'" :loading="get_isLoading" @click="toLogout">Выход</ButtonMain>
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { useStore } from 'vuex';
  import { useRouter } from 'vue-router';
  import { getCookie } from '@shared/utils/auth.js';
  import { backendUrl } from "@shared/constants/urls/appUrls";
  import DROPDOWN_NAMES from '@shared/constants/dropdowns/dropdownsName.js';
  //---------------------------------------
  import ButtonMain from '@shared/UI/Buttons/ButtonMain/ButtonMain.vue';
  //---------------------------------------
  const store = useStore();
  const router = useRouter();
  //---------------------------------------
  const LOGOUT_ENDPOINT = `${ backendUrl }/api/token/blacklist/`;
  //---------------------------------------
  //Статус отправки данных
  const get_isLoading = computed(() => store.state.AuthorizationSystem.isLoading)
  //---------------------------------------
  //Запустить процесс разлогинивания
  const toLogout = async () => {
    toChangeLoadingFlag(true);
    try {
      await fetch(LOGOUT_ENDPOINT, {
        method: 'POST',
        credentials: 'include', // Включаем отправку куков
        headers: {'Content-Type': 'application/json'},
      });
      store.commit('UserSystem/clearUserData');
      await store.dispatch('logout');
      await router.push('/');
      toChangeLoadingFlag(false);
      toCloseWidget();
    } catch (error) {
      toChangeLoadingFlag(false);
      console.error('Logout error:', error);
    }
  };
  //Отметить процесс отправки данных на сервер
  const toChangeLoadingFlag = (status) => store.commit('AuthorizationSystem/toChangeLoadingFlag', status);
  //Закрыть попап с авторизацией
  const toCloseWidget = () => store.dispatch('Dropdowns/removeTheDropdown', DROPDOWN_NAMES.auth);
</script>

<style lang="scss">
  @import '../../styles/Wdgt-Auth-Module.scss';
</style>
